import React from "react"
import classes from "./YellowDivider.module.css"

const FullWidthYellowDivider = () => {
  return <div className={classes.fullWidthYellowDivider} />;
};

export default FullWidthYellowDivider;
